import React from "react"
import { useIntl } from "gatsby-plugin-intl"

//Components
import Layout from "../components/layout"
import List from "../components/list"
import Seo from "../components/seo"

//Styles
import todoStyles from "./todo.module.scss"

export default () => {
  const intl = useIntl()
  let list1 = []
  let list2 = []
  for (let i = 1; i <= 2; i++) {
    list1.push([
      intl.formatMessage({ id: `todo__list_1_title_${i}` }),
      intl.formatMessage({ id: `todo__list_1_content_${i}` }),
    ])
  }
  for (let i = 1; i <= 8; i++) {
    list2.push([
      intl.formatMessage({ id: `todo__list_2_title_${i}` }),
      intl.formatMessage({ id: `todo__list_2_content_${i}` }),
    ])
  }
  
  return (
    <Layout>
      <Seo title={intl.formatMessage({ id: "todo__title" })} />
      <div className={todoStyles.container}>
        <h1>{intl.formatMessage({ id: "todo__title" })}</h1>
        <section className={todoStyles.content}>
          <List
            description={intl.formatMessage({ id: "todo__description_1" })}
            items={list1}
          />
          <br />
          <List
            description={intl.formatMessage({ id: "todo__description_1" })}
            items={list2}
          />
        </section>
      </div>
    </Layout>
  )
}
